module.exports = __webpack_public_path__ + "img/goods7_4.a60af72b.jpg";